import PrimarySelect from '@mm/components/legacy-components/PrimarySelect/PrimarySelect';

export * from '@mm/components/legacy-components/PrimarySelect/PrimarySelect';
export default PrimarySelect;
